import React from "react";
import PropTypes from "prop-types";
import { Box } from "rebass";
import { css } from "styled-components";
import theme from "../../theme";

export const Radio = (
  { color = theme.colors.red, handleClick } // eslint-disable-line
) => (
  <Box as="span" onClick={handleClick}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M12 15a5.006 5.006 0 005-5V6A5 5 0 007 6v4a5.006 5.006 0 005 5zM9 6a3 3 0 016 0v4a3 3 0 01-6 0zm-6 4V8a1 1 0 012 0v2a7 7 0 0014 0V8a1 1 0 012 0v2a9.011 9.011 0 01-8 8.941V21h3a1 1 0 010 2H8a1 1 0 010-2h3v-2.059A9.011 9.011 0 013 10z" />
    </svg>
  </Box>
);

export const Facebook = () => (
  <svg viewBox="0 0 512 512" preserveAspectRatio="xMidYMid meet">
    <path d="M211.9 197.4h-36.7v59.9h36.7V433.1h70.5V256.5h49.2l5.2-59.1h-54.4c0 0 0-22.1 0-33.7 0-13.9 2.8-19.5 16.3-19.5 10.9 0 38.2 0 38.2 0V82.9c0 0-40.2 0-48.8 0 -52.5 0-76.1 23.1-76.1 67.3C211.9 188.8 211.9 197.4 211.9 197.4z"></path>
  </svg>
);

export const Instagram = () => (
  <svg viewBox="0 0 512 512" preserveAspectRatio="xMidYMid meet">
    <path d="M256 109.3c47.8 0 53.4 0.2 72.3 1 17.4 0.8 26.9 3.7 33.2 6.2 8.4 3.2 14.3 7.1 20.6 13.4 6.3 6.3 10.1 12.2 13.4 20.6 2.5 6.3 5.4 15.8 6.2 33.2 0.9 18.9 1 24.5 1 72.3s-0.2 53.4-1 72.3c-0.8 17.4-3.7 26.9-6.2 33.2 -3.2 8.4-7.1 14.3-13.4 20.6 -6.3 6.3-12.2 10.1-20.6 13.4 -6.3 2.5-15.8 5.4-33.2 6.2 -18.9 0.9-24.5 1-72.3 1s-53.4-0.2-72.3-1c-17.4-0.8-26.9-3.7-33.2-6.2 -8.4-3.2-14.3-7.1-20.6-13.4 -6.3-6.3-10.1-12.2-13.4-20.6 -2.5-6.3-5.4-15.8-6.2-33.2 -0.9-18.9-1-24.5-1-72.3s0.2-53.4 1-72.3c0.8-17.4 3.7-26.9 6.2-33.2 3.2-8.4 7.1-14.3 13.4-20.6 6.3-6.3 12.2-10.1 20.6-13.4 6.3-2.5 15.8-5.4 33.2-6.2C202.6 109.5 208.2 109.3 256 109.3M256 77.1c-48.6 0-54.7 0.2-73.8 1.1 -19 0.9-32.1 3.9-43.4 8.3 -11.8 4.6-21.7 10.7-31.7 20.6 -9.9 9.9-16.1 19.9-20.6 31.7 -4.4 11.4-7.4 24.4-8.3 43.4 -0.9 19.1-1.1 25.2-1.1 73.8 0 48.6 0.2 54.7 1.1 73.8 0.9 19 3.9 32.1 8.3 43.4 4.6 11.8 10.7 21.7 20.6 31.7 9.9 9.9 19.9 16.1 31.7 20.6 11.4 4.4 24.4 7.4 43.4 8.3 19.1 0.9 25.2 1.1 73.8 1.1s54.7-0.2 73.8-1.1c19-0.9 32.1-3.9 43.4-8.3 11.8-4.6 21.7-10.7 31.7-20.6 9.9-9.9 16.1-19.9 20.6-31.7 4.4-11.4 7.4-24.4 8.3-43.4 0.9-19.1 1.1-25.2 1.1-73.8s-0.2-54.7-1.1-73.8c-0.9-19-3.9-32.1-8.3-43.4 -4.6-11.8-10.7-21.7-20.6-31.7 -9.9-9.9-19.9-16.1-31.7-20.6 -11.4-4.4-24.4-7.4-43.4-8.3C310.7 77.3 304.6 77.1 256 77.1L256 77.1z"></path>
    <path d="M256 164.1c-50.7 0-91.9 41.1-91.9 91.9s41.1 91.9 91.9 91.9 91.9-41.1 91.9-91.9S306.7 164.1 256 164.1zM256 315.6c-32.9 0-59.6-26.7-59.6-59.6s26.7-59.6 59.6-59.6 59.6 26.7 59.6 59.6S288.9 315.6 256 315.6z"></path>
    <circle cx="351.5" cy="160.5" r="21.5"></circle>
  </svg>
);

export const Icon = (
  { icon: Icon } // eslint-disable-line
) => (
  <Box mr={2} width="40px" height="40px">
    <Box as="span" css={{ fill: theme.colors.red }}>
      <Icon />
    </Box>
  </Box>
);

Icon.propTypes = {
  icon: PropTypes.object.isRequired,
};
export const IconWithLink = ({ link, icon: I, ...rest }) => (
  <Box
    width="40px"
    height="40px"
    css={{
      borderLeft: "1px solid",
    }}
    {...rest}
  >
    <a
      css={{ fill: theme.colors.red }}
      href={link}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Box as="span" css={{ fill: theme.colors.red }}>
        <I />
      </Box>
    </a>
  </Box>
);
IconWithLink.propTypes = {
  link: PropTypes.string.isRequired,
  icon: PropTypes.elementType.isRequired,
};
